var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"maxWidth",attrs:{"cols":12,"lg":_vm.width}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }